import { Button } from "@material-ui/core";
import { addDoc, collection } from "firebase/firestore";
import React, { useRef } from "react";
import ReactDOM from "react-dom";

import { db } from "../../services/firebase";
import { ModalBackground, ModalContent } from "./Modal.elements";

function Modal({ onClose }) {
  const channelName = useRef();

  const addChannel = () => {
    if (channelName.current.value) {
      addDoc(collection(db, "rooms"), {
        name: channelName.current.value,
      });
    }
    onClose();
  };

  return ReactDOM.createPortal(
    <ModalBackground>
      <ModalContent>
        <Button className="btn-close" onClick={onClose}>
          Close
        </Button>
        <h3>Please enter the channel name:</h3>
        <input type="text" ref={channelName} />
        <Button className="btn-add" onClick={addChannel}>
          Make new channel
        </Button>
      </ModalContent>
    </ModalBackground>,
    document.getElementById("modal-root")
  );
}

export default Modal;
